export enum Tool {
  AEROSOL,
  APPLICATOR,
  BUCKET,
  BRUSH,
  ERASER,
  ELLIPSE,
  FEATHER_PEN,
  GRID,
  LINE,
  PENCIL,
  PIPETTE,
  POLYGONE,
  RECTANGLE,
  SELECTION,
  TEXT,
  _Len,
  _None
}
